import { type TrackingProperties, track } from 'modules/core/lib/Tracking'

export const multiTrack = (eventKeys: string[], data: TrackingProperties) => {
  eventKeys.forEach((eventKey) => track(eventKey, data))
}
